import { render, staticRenderFns } from "./Enlace.vue?vue&type=template&id=4e0d16b3&scoped=true"
import script from "./Enlace.vue?vue&type=script&lang=js"
export * from "./Enlace.vue?vue&type=script&lang=js"
import style0 from "./Enlace.vue?vue&type=style&index=0&id=4e0d16b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0d16b3",
  null
  
)

export default component.exports